var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/DionCookieService.ts
import Cookies from "js-cookie";
var DionCookieService = class {
  constructor() {
    __publicField(this, "defaultOptions", {
      domain: ".dion.vc",
      expires: 365
    });
    this.defaultOptions = __spreadProps(__spreadValues({}, this.defaultOptions), {
      domain: this.getDefaultDomainName()
    });
  }
  getDefaultDomainName() {
    return typeof window !== "undefined" ? "." + window.location.hostname.split(".").slice(-2).join(".") : ".dion.vc";
  }
  getCookieOptions(options) {
    return __spreadValues(__spreadValues({}, this.defaultOptions), options);
  }
  set(name, value, options = {}) {
    const preparedOptions = this.getCookieOptions(options);
    Cookies.set(name, value, preparedOptions);
  }
  get(name) {
    return Cookies.get(name);
  }
  remove(name, options = {}) {
    const preparedOptions = this.getCookieOptions(options);
    Cookies.remove(name, preparedOptions);
  }
  setDomain(domain) {
    this.defaultOptions = __spreadProps(__spreadValues({}, this.defaultOptions), {
      domain
    });
  }
};
var dionCookieService = new DionCookieService();
export {
  dionCookieService
};
